import React, { useEffect } from 'react'

// Owns one Blackbaud component's DOM lifecycle. Both components inline mode
// exposes (inlineCheckout / completeCheckoutButton) share the same
// mount(containerId) + unmount() contract, so one wrapper covers both.
//
// This is what lets the workflow object live at App level while its components
// live inside panels: Panel renders `{status && children}`, so a panel the donor
// navigates away from unmounts and this effect's cleanup runs, but the
// `checkout` instance (paymentMode, baseAmount, billingDetails,
// checkoutSessionId) is untouched and the next visit re-mounts against it.
//
// Blackbaud's mount() does getElementById and throws when the target is
// missing, so it has to run in an effect — after React has committed the div.
//
// `buttonId` is only used by completeCheckoutButtonComponent, whose mount takes
// a second argument naming OUR button element to bind the authorization to.
const BlackbaudSlot = ({ component, id, buttonId, className }) => {
  useEffect(() => {
    if (!component) return

    try {
      component.mount(id, buttonId)
    } catch (error) {
      // A throw here means the container went missing between render and
      // effect. Don't take the whole panel down with it — the donor still has
      // a Back link, and the missing component surfaces as an absent field
      // rather than a blank widget.
      console.error('Error mounting Blackbaud component:', error)
      return
    }

    return () => component.unmount?.()
  }, [ component, id, buttonId ])

  return <div id={id} className={className} />
}

export default BlackbaudSlot
